import State from "slotworks/state-machine/states/state";
import Sequence from "slotworks/utils/contracts/sequence";
import Contract from "slotworks/utils/contracts/contract";
import { Services } from "slotworks/services/services";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import gateway from "components/gateway";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import gameState from "slotworks/model/game-state";
import Layers from "slotworks/graphics/layers/layers";
import { LLCustomLayers } from "../../../lib/luck-and-luxury/src/names";

export class CGMCBonusWildEnter extends State {

    public onEnter() {

        smartUiFlags.set(SmartUIFlag.FREE_SPINS, true);

        if (Layers.Background.hasScene("pick_bonus")) {
            Layers.Background.setScene("pick_bonus").execute();
        }
        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("pick_bonus")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("pick_bonus").execute();
        }

        this.playAnimation().then(() => this.complete());
    }

    public onExit() {
        // prevent bonus flag being disabled.

        if (Layers.Background.hasScene("default")) {
            Layers.Background.setScene("default").execute();
        }
        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("default")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("default").execute();
        }
    }

    protected playAnimation() {

        const record = gameState.getCurrentGame().getCurrentRecord();
        const winningSymbols = this.getSymbolsById("WW_BN");
        const promptContent = new PromptContent(["fortune_blast_wild"], 4000);
        const wildBonusResult = record.getResultsOfType(LLWildSymbolResult)[0];

        return new Sequence([
            // () => Contract.wrap(() => winningSymbols.forEach((symbol) => symbol.highlight().then(() => symbol.static()))),
            () => Components.footer.showCustomResult(wildBonusResult, "wild_fortune_blast_win", {}),
            // () => Contract.wrap(() => Services.sound.customEvent("ww")),
            // () => Contract.getTimeoutContract(1800),
            () => Contract.wrap(() => Services.sound.customEvent("fortune_blast_music_intro")),
            () => Components.prompt.showPrompt(promptContent),
            () => gateway.playOutroFire()
        ]);
    }

    protected getSymbolsById(symbolId: string) {
        return Components.matrix.getGridSymbols().filter((symbol) => {
            return symbol.symbolId === symbolId;
        });
    }
}
